import type { TestPlan } from './plans-api.js';

// #55: Mehrere Testpläne dürfen gleichzeitig aktiv sein. Wo ein Plan nicht ausdrücklich gewählt
// ist, braucht es deshalb eine verbindliche Reihenfolge — sonst entscheidet die Zufallsreihenfolge
// der Datenbank, welcher Plan Digest, Sign-off-Evidenz oder Tester-Playlist bestimmt.
// Fachlich gewinnt der Plan mit dem NÄCHSTEN Zieltermin: er ist der dringendste. Pläne ohne
// Zieltermin kommen zuletzt, bei Gleichstand entscheidet das Anlagedatum.
// Branch-Review K4: haben zwei Pläne ZUSÄTZLICH dasselbe Anlagedatum (Sekundengenauigkeit reicht
// nicht immer), bräuchte es noch ein drittes, stabiles Kriterium — sonst würde clientseitig einfach
// die Eingabereihenfolge gewinnen, während dieselbe Konstellation serverseitig (Postgres) beliebig
// sortiert. `test_plan_id` ist als UUID eindeutig und ändert sich nie, also ein sicherer Tiebreaker.
// Dieselbe Regel steht serverseitig in apps/api/src/services/plan-selection.ts.
export function sortActivePlans(plans: TestPlan[]): TestPlan[] {
  return (
    plans
      // #114 (A9): `is_active` ist durch den Lebenszyklus ersetzt. „Aktiv" heißt jetzt genau
      // status === 'aktiv' — ein abgeschlossener Plan verschwindet damit aus Digest, Playlist und
      // Sign-off-Vorauswahl, bleibt aber im Reporting lesbar (dieselbe Regel serverseitig in
      // services/plan-selection.ts).
      .filter((p) => p.status === 'aktiv')
      .slice()
      .sort((a, b) => {
        if (a.target_date !== b.target_date) {
          if (a.target_date === null) return 1;
          if (b.target_date === null) return -1;
          return a.target_date < b.target_date ? -1 : 1;
        }
        if (a.created_at !== b.created_at) {
          return a.created_at < b.created_at ? -1 : 1;
        }
        return a.test_plan_id < b.test_plan_id ? -1 : a.test_plan_id > b.test_plan_id ? 1 : 0;
      })
  );
}

export function defaultActivePlanId(plans: TestPlan[]): string | null {
  return sortActivePlans(plans)[0]?.test_plan_id ?? null;
}
